module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Help")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "http://www.bpmnquickguide.com/quickguide/",
      "scrolling": "auto",
      "frameborder": "0",
      "width": "100%",
      "height": "700px"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-630d4d9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Help.vue
// module id = 53
// module chunks = 1 2